
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic10Off as ObiHydraulic10OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-10-off.js';
 
 
 

 
 export const ObiHydraulic10Off = createComponent({
   react: React,
   tagName: 'obi-hydraulic-10-off',
   elementClass: ObiHydraulic10OffElement,
   events: {
     
   }
  });
 
 